import { render, staticRenderFns } from "./TextBoxTitleTwo.vue?vue&type=template&id=18fbfd0e&scoped=true&"
import script from "./TextBoxTitleTwo.vue?vue&type=script&lang=js&"
export * from "./TextBoxTitleTwo.vue?vue&type=script&lang=js&"
import style0 from "./TextBoxTitleTwo.vue?vue&type=style&index=0&id=18fbfd0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fbfd0e",
  null
  
)

export default component.exports